export const THEME_ACTION_TYPES = {
  SET_THEME: "theme/SET_THEME",
};
